let config = {
  auth: {
    host: {
      dev: {
        au: 'https://auth.dev.leap.services',
      },
      test: {
        au: 'https://login.test.leap365.com.au',
        uk: 'https://login.test.leap365.co.uk',
        us: 'https://login.test.leap365.com',
        ca: 'https://login.test.leap365.ca',
        nz: 'https://login.test.leap365.co.nz',
      },
      live: {
        au: 'https://login.leap365.com.au',
        uk: 'https://login.leap365.co.uk',
        us: 'https://login.leap365.com',
        ca: 'https://login.leap365.ca',
        nz: 'https://login.leap365.co.nz',
      },
    },
    refreshTokenService: {
      dev: 'https://auth.dev.leap.services/oauth/token',
      test: 'https://auth-test.leap.services/oauth/token',
      live: 'https://auth.leap.services/oauth/token',
    },
  },
};

export { config };
